import { useTranslation } from 'react-i18next';
import ODropDownMenu from '../../../../../UI/DropDownMenu/ODropDownMenu';
import { colors } from '../../../../../../../shared/colors';

const GridOptionsFajlovi = ({
  children,
  openFile,
  handleOpenDeleteDialog,
  downloadFile,
  canManage,
}) => {
  const { t } = useTranslation();

  const muiOptions = [
    {
      title: t('projectProgress.openFile'),
      subtitle: t('projectProgress.openFile'),
      id: 1,
      icon: 'fas fa-file',
      color: colors.EDIT,
      onClick: () => openFile(),
    },
    {
      title: t('projectProgress.downloadFile'),
      subtitle: t('projectProgress.downloadFile'),
      id: 3,
      icon: 'fas fa-file-download',
      color: colors.EDIT,
      onClick: () => downloadFile(),
    },
  ];

  if (canManage) {
    muiOptions.push({
      title: t('projectProgress.deleteFile'),
      subtitle: t('projectProgress.deleteFile'),
      path: 'login',
      id: 2,
      icon: 'fas fa-trash',
      color: '#ff5552',
      onClick: () => handleOpenDeleteDialog(),
    });
  }

  return (
    <ODropDownMenu align="end" position="anchor" options={muiOptions}>
      {children}
    </ODropDownMenu>
  );
};

export default GridOptionsFajlovi;
